module.exports = __webpack_public_path__ + "img/thank-img-hover.79e91fbd.png";